module.exports = __webpack_public_path__ + "static/media/de_get.d25ef950.svg";